import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlanDetailComponent } from './plan-detail/plan-detail.component';
import { IonicModule } from '@ionic/angular';
import { PipeModule } from 'src/app/pipes/pipe-module.module';
import { SubscriptionComponentsModule } from 'src/app/pages/admin/pages-admin/subscriptions/subscription-components/subscription-components.module';

const declarations = [PlanDetailComponent];

@NgModule({
  declarations,
  imports: [
    CommonModule,
    IonicModule,
    PipeModule,
    SubscriptionComponentsModule,
  ],
  exports: declarations,
})
export class StatusComponentsModule {}
